import { useEffect, useState } from "react";
import { toast } from "sonner";
import { useApi, errMsg, ago } from "@/lib/api";

export const RailEntry = ({ m, onSaved }) => {
  const api = useApi();
  const [rail, setRail] = useState(m.rail || "");
  const [busy, setBusy] = useState(false);
  useEffect(() => { setRail(m.rail || ""); }, [m.id, m.rail]);

  const save = async () => {
    if (busy || rail === (m.rail || "")) return;
    setBusy(true);
    try { await api("put", `/admin/meetings/${m.id}/rail`, { rail }); toast.success(rail.trim() ? "Rail saved" : "Rail cleared"); onSaved(); }
    catch (e) { toast.error(errMsg(e)); }
    finally { setBusy(false); }
  };

  return (
    <div className="flex flex-wrap items-center gap-2 mb-6 text-xs" data-testid="rail-entry">
      <label htmlFor="rail-input" className="text-slate-400">Today's rail</label>
      <input id="rail-input" data-testid="rail-input" value={rail} maxLength={80} onChange={(e) => setRail(e.target.value)}
        onKeyDown={(e) => e.key === "Enter" && save()} placeholder="e.g. True Entire Circuit or +3m Entire Course"
        className="flex-1 min-w-[200px] max-w-md bg-[#0B101D] border border-white/10 rounded-lg px-3 py-1.5 text-sm focus:outline-none focus:border-blue-500" />
      <button data-testid="rail-save-button" onClick={save} disabled={busy || rail === (m.rail || "")}
        className="px-3 py-1.5 rounded-full bg-blue-600 hover:bg-blue-500 font-semibold disabled:opacity-50">Save rail</button>
      <span className="text-slate-500" data-testid="rail-updated">{m.rail_updated_at ? `Saved ${ago(m.rail_updated_at)} · used by the AI and shown to visitors` : "Copy it from the official track information. Used by the AI and shown to visitors."}</span>
    </div>
  );
};
